(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
/* Single-open behavior: when a <details> inside a [data-faq-single-open]
   container opens, close its siblings. Uses the native 'toggle' event so
   it works with the existing <accordion-tab> wrapper without touching its
   internals. */
document.addEventListener('toggle', (e) => {
  const details = e.target;
  if (!(details instanceof HTMLDetailsElement)) return;
  if (!details.open) return;
  const container = details.closest('[data-faq-single-open]');
  if (!container) return;
  container.querySelectorAll('details[open]').forEach((d) => {
    if (d !== details) d.open = false;
  });
}, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fd-quiz-results"] && !Shopify.designMode) return;
  try {
    
  // Hide header immediately on page load
  document.documentElement.classList.add('fd-quiz--header-hidden');

  if (!customElements.get('fd-quiz-results')) {
    class FdQuizResults extends HTMLElement {
      connectedCallback() {
        this.config = {
          planId: this.dataset.planId,
          discountCode: this.dataset.discountCode,
          discountLabel: this.dataset.discountLabel,
          gwpThreshold: parseFloat(this.dataset.gwpThreshold) || 60,
          gwpText: this.dataset.gwpText || '',
          showGwpPerCard: this.dataset.showGwpPerCard === 'true',
          maxProducts: parseInt(this.dataset.maxProducts, 10) || 3,
          reportPrefix: this.dataset.reportNumberPrefix || 'FD-',
          classificationMap: this.#parseClassificationMap(this.dataset.classifications),
          previewMode: this.dataset.previewMode === 'true'
        };

        // In preview mode, all content is already server-rendered.
        // Skip the JS rendering pipeline so we don't overwrite the sample.
        if (this.config.previewMode) return;

        this.#bindHandlers();
        document.addEventListener('octane.quiz.completed', this.handleQuizCompleted);
        document.addEventListener('change', this.handleRadioChange);
      }

      disconnectedCallback() {
        if (this.config?.previewMode) return;
        document.removeEventListener('octane.quiz.completed', this.handleQuizCompleted);
        document.removeEventListener('change', this.handleRadioChange);
      }

      #bindHandlers() {
        this.handleQuizCompleted = this.#onQuizCompleted.bind(this);
        this.handleRadioChange = (e) => {
          if (e.target?.type === 'radio') this.#lockSelectPlan();
        };
      }

      #parseClassificationMap(raw) {
        const map = {};
        if (!raw) return { 1: 'Critical Risk', 2: 'Critical Risk', 3: 'High Risk', 4: 'High Risk' };
        for (const pair of raw.split(',')) {
          const [score, label] = pair.split(':').map(p => p.trim());
          if (score && label) map[score] = label;
        }
        return map;
      }

      async #onQuizCompleted(event) {
        const detail = event.detail || {};
        console.log('[fd-quiz-results] quiz data:', detail);

        document.documentElement.classList.remove('fd-quiz--header-hidden');
        this.#hideOctaneDefaultContainer();
        this.#lockSelectPlan();

        const smartCopy = this.#findSmartCopy(detail);
        const products = (detail.product_blocks || []).flat().slice(0, this.config.maxProducts);
        if (!smartCopy || products.length === 0) return;

        const parsed = this.#parseSmartCopy(smartCopy);
        this.#renderScore(parsed.score);
        this.#renderClassification(parsed.score);
        this.#renderTickMarker(parsed.score);
        this.#renderSituation(parsed.situation);
        this.#renderChecklist(parsed.items);
        this.#renderMetadata(detail);
        this.#renderReportNumber();

        await this.#renderProducts(products, parsed.reasonMap, parsed.reasonsList);

        this.removeAttribute('hidden');
      }

      #hideOctaneDefaultContainer() {
        const containers = document.querySelectorAll('.custom-liquid-outer-container');
        if (containers[0]) {
          containers[0].style.setProperty('display', 'none', 'important');
        }
      }

      #lockSelectPlan() {
        const selects = document.querySelectorAll('select[aria-label="Choose a plan"]');
        for (const select of selects) {
          [...select.options]
            .filter(opt => opt.value !== this.config.planId)
            .forEach(opt => opt.remove());
          select.value = this.config.planId;
        }
      }

      #findSmartCopy(obj, depth = 0) {
        if (!obj || typeof obj !== 'object' || depth > 8) return null;

        if (typeof obj['smart-copy'] === 'string' && obj['smart-copy'].trim()) {
          return obj['smart-copy'];
        }
        if (obj.smart_copies_outputs && typeof obj.smart_copies_outputs === 'object') {
          const v = obj.smart_copies_outputs['smart-copy'];
          if (typeof v === 'string' && v.trim()) return v;
        }
        if (obj.smart_copies && typeof obj.smart_copies === 'object') {
          const v = Object.values(obj.smart_copies).find(x => typeof x === 'string' && x.trim());
          if (v) return v;
        }
        if (obj.internal_name === 'smart-copy' && typeof obj.text === 'string' && obj.text.trim()) {
          return obj.text;
        }
        for (const key of Object.keys(obj)) {
          const child = obj[key];
          if (child && typeof child === 'object') {
            const found = this.#findSmartCopy(child, depth + 1);
            if (found) return found;
          }
        }
        return null;
      }

      #parseSmartCopy(html) {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const paragraphs = [...doc.querySelectorAll('p')];
        const items = [...doc.querySelectorAll('li')]
          .filter(li => !li.closest('#fd-product-reasons'))
          .map(li => li.textContent.trim());

        let score = null;
        const strong = doc.querySelector('strong');
        if (strong) {
          // Matches both "Family Nutrition Score: X/10" and legacy "Risk Level: X/10"
          const match = strong.textContent.match(/(\d+)\s*\/\s*10/);
          if (match) score = parseInt(match[1], 10);
        }

        let situation = '';
        for (const p of paragraphs) {
          const text = p.textContent.trim();
          if (p.querySelector('strong')) continue;
          if (/why this plan fits/i.test(text)) continue;
          if (text) { situation = text; break; }
        }

        const reasonMap = {};
        const reasonsList = [];
        doc.querySelectorAll('#fd-product-reasons li').forEach(li => {
          const text = li.textContent.trim();
          if (li.dataset.handle) reasonMap[li.dataset.handle] = text;
          reasonsList.push(text);
        });
        console.log('[fd-quiz] reasonMap:', reasonMap, 'reasonsList:', reasonsList);

        return { score, situation, items, reasonMap, reasonsList };
      }

      #renderScore(score) {
        const el = this.querySelector('[data-score-number]');
        if (el) el.textContent = score != null ? score : '—';
      }

      #renderClassification(score) {
        const el = this.querySelector('[data-classification]');
        if (!el || score == null) return;
        el.textContent = this.config.classificationMap[String(score)] || 'High Risk';
      }

      #renderTickMarker(score) {
        const marker = this.querySelector('[data-tick-marker]');
        if (!marker || score == null) return;
        const pct = Math.max(0, Math.min(100, (score / 10) * 100));
        requestAnimationFrame(() => { marker.style.left = `${pct}%`; });
      }

      #renderSituation(text) {
        const el = this.querySelector('[data-situation]');
        if (el) el.textContent = text || '';
      }

      #renderChecklist(items) {
        const ol = this.querySelector('[data-checklist]');
        if (!ol) return;
        ol.innerHTML = '';
        items.forEach((text, i) => {
          const li = document.createElement('li');
          const num = document.createElement('span');
          num.className = 'fd-report__check-num';
          num.textContent = String(i + 1).padStart(2, '0');
          const body = document.createElement('span');
          body.textContent = text;
          li.append(num, body);
          ol.appendChild(li);
        });
      }

      #renderMetadata(detail) {
        const emailEl = this.querySelector('[data-field-email]');
        const responsesEl = this.querySelector('[data-field-responses]');

        if (emailEl) {
          const email = this.#findEmail(detail);
          emailEl.textContent = email ? this.#maskEmail(email) : 'Anonymous';
        }
        if (responsesEl) {
          const count = this.#countResponses(detail);
          responsesEl.textContent = count ? `${count} of ${count}` : 'Complete';
        }
      }

      #findEmail(obj, depth = 0) {
        if (!obj || typeof obj !== 'object' || depth > 6) return null;
        if (typeof obj.email === 'string' && obj.email.includes('@')) return obj.email;
        for (const key of Object.keys(obj)) {
          const child = obj[key];
          if (child && typeof child === 'object') {
            const found = this.#findEmail(child, depth + 1);
            if (found) return found;
          }
        }
        return null;
      }

      #maskEmail(email) {
        const [local, domain] = email.split('@');
        if (!local || !domain) return email;
        const visible = local.slice(0, 2);
        return `${visible}•••@${domain}`;
      }

      #countResponses(detail) {
        if (Array.isArray(detail.answers)) return detail.answers.length;
        if (detail.answers && typeof detail.answers === 'object') {
          return Object.keys(detail.answers).length;
        }
        return null;
      }

      #renderReportNumber() {
        const el = this.querySelector('[data-report-number]');
        if (!el) return;
        const num = Math.floor(1000 + Math.random() * 9000);
        const date = new Date();
        const mm = String(date.getMonth() + 1).padStart(2, '0');
        const dd = String(date.getDate()).padStart(2, '0');
        const yyyy = date.getFullYear();
        el.innerHTML = `Report No. ${this.config.reportPrefix}${num}<br>Issued ${mm}.${dd}.${yyyy}`;
      }

      async #fetchProductData(link) {
        try {
          const handle = link.split('/products/')[1]?.split('?')[0];
          if (!handle) return null;
          const res = await fetch(`/products/${handle}.js`);
          if (!res.ok) return null;
          const data = await res.json();
          const compareAt = data.compare_at_price;
          return {
            price: (data.price / 100).toFixed(2),
            compareAtPrice: compareAt && compareAt > data.price ? (compareAt / 100).toFixed(2) : null,
            variantId: data.variants?.[0]?.id ?? null
          };
        } catch {
          return null;
        }
      }

      #openAndRefreshCart() {
        fetch('/cart.js')
          .then(r => r.json())
          .then(cart => {
            if (typeof toggleCartOpen === 'function') toggleCartOpen();
            if (typeof updateCartDisplay === 'function') updateCartDisplay(cart);
            if (typeof updateCartCount === 'function') updateCartCount(cart.item_count);
            const flyout = document.querySelector('.firstday-cart__flyout-content.has-items');
            if (flyout) flyout.scrollTop = 0;
          });
      }

      #addToCart(variantId, btn) {
        if (!variantId) return;
        btn.disabled = true;
        btn.textContent = 'Adding…';
        const items = [{
          id: variantId,
          quantity: 1,
          selling_plan: this.config.planId,
          properties: {
            '_full_price': 'true',
            '_product_type': 'rebrand',
            '_is_subscription_purchase': true
          }
        }];
        window.addToCart({ items })
          .then(response => response.json())
          .then(() => {
            btn.textContent = 'Added!';
            this.#openAndRefreshCart();
          })
          .catch(() => {
            // Beam Impact CORS errors cause false rejections — verify via /cart.js
            fetch('/cart.js')
              .then(r => r.json())
              .then(cart => {
                const added = cart.items.some(i => String(i.variant_id) === String(variantId));
                if (added) {
                  btn.textContent = 'Added!';
                  this.#openAndRefreshCart();
                } else {
                  btn.textContent = 'Error — try again';
                  btn.disabled = false;
                }
              })
              .catch(() => {
                btn.textContent = 'Error — try again';
                btn.disabled = false;
              });
          });
      }

      async #renderProducts(products, reasonMap = {}, reasonsList = []) {
        const grid = this.querySelector('[data-products]');
        if (!grid) return;
        grid.innerHTML = '';

        const cards = await Promise.all(
          products.map(async (p, i) => {
            const productData = await this.#fetchProductData(p.link);
            return this.#buildProductCard(p, productData, reasonMap, reasonsList, i);
          })
        );
        cards.forEach(card => grid.appendChild(card));
      }

      #buildProductCard(product, productData, reasonMap = {}, reasonsList = [], index = 0) {
        const price = productData?.price ?? null;
        const compareAtPrice = productData?.compareAtPrice ?? null;
        const variantId = productData?.variantId ?? null;
        const handle = product.link?.split('/products/')[1]?.split('?')[0] ?? '';
        const reason = reasonMap[handle] || reasonsList[index] || '';
        console.log('[fd-quiz] card handle:', handle, '→ reason:', reason);

        const card = document.createElement('div');
        card.className = 'fd-product';

        const imgLink = document.createElement('a');
        imgLink.className = 'fd-product__img-wrap';
        imgLink.href = product.link;
        imgLink.tabIndex = -1;
        imgLink.setAttribute('aria-hidden', 'true');
        if (product.image) {
          const img = document.createElement('img');
          img.className = 'fd-product__img';
          img.src = product.image;
          img.alt = product.title || '';
          img.loading = 'lazy';
          imgLink.appendChild(img);
        }
        card.appendChild(imgLink);

        const body = document.createElement('div');
        body.className = 'fd-product__body';

        const titleLink = document.createElement('a');
        titleLink.className = 'fd-product__title';
        titleLink.href = product.link;
        titleLink.textContent = product.title || '';
        body.appendChild(titleLink);

        const priceRow = document.createElement('div');
        priceRow.className = 'fd-product__price-row';
        if (compareAtPrice) {
          const oldPrice = document.createElement('span');
          oldPrice.className = 'fd-product__price--compare';
          oldPrice.textContent = `$${compareAtPrice}`;
          priceRow.appendChild(oldPrice);
        }
        if (price) {
          const priceEl = document.createElement('span');
          priceEl.className = `fd-product__price${compareAtPrice ? ' fd-product__price--sale' : ''}`;
          priceEl.textContent = `$${price}`;
          priceRow.appendChild(priceEl);
        }
        if (this.config.discountLabel) {
          const badge = document.createElement('span');
          badge.className = 'fd-product__discount-badge';
          badge.textContent = this.config.discountLabel;
          priceRow.appendChild(badge);
        }
        if (priceRow.childElementCount) body.appendChild(priceRow);

        if (reason) {
          const reasonEl = document.createElement('div');
          reasonEl.className = 'fd-product__reason';
          reasonEl.innerHTML = `<span class="fd-product__reason-icon">✦</span><span class="fd-product__reason-text">${reason}</span>`;
          body.appendChild(reasonEl);
        } else if (this.config.showGwpPerCard && this.config.gwpText) {
          const gwp = document.createElement('p');
          gwp.className = 'fd-product__gwp';
          gwp.textContent = this.config.gwpText;
          body.appendChild(gwp);
        }

        const ctaWrap = document.createElement('div');
        ctaWrap.className = 'fd-product__cta';
        const btn = document.createElement('button');
        btn.className = 'fd-product__link';
        btn.type = 'button';
        btn.textContent = 'Add To Cart';
        btn.addEventListener('click', () => this.#addToCart(variantId, btn));
        ctaWrap.appendChild(btn);
        body.appendChild(ctaWrap);

        card.appendChild(body);

        return card;
      }
    }

    customElements.define('fd-quiz-results', FdQuizResults);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();

      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);

      if (this.classList.contains('on-header')) {
        document.body.classList.remove('localization--open');
      }
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      // this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      // this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());

      if (this.classList.contains('on-header')) {
        document.body.classList.toggle('localization--open');
      }
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }
  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["temp-bundle-builder"] && !Shopify.designMode) return;
  try {
    
class FirstDayBundle extends HTMLElement {
  #tiers = [];
  #maxSlots = 5;
  /** Map<productId, {product, qty, variantId, price, compare, image}> */
  #cart = new Map();
  /** Active filters per group */
  #filters = { line: new Set(), demo: new Set() };
  #openModalCard = null;
  #modal = null;
  /** Whether at least one add-to-bundle has occurred (drawer auto-expand only fires on the very first add) */
  #hasAddedOnce = false;

  connectedCallback() {
    this.#maxSlots = parseInt(this.dataset.maxSlots, 10) || 5;
    this.#tiers = this.#readTiers();
    this.#bindCards();
    this.#bindCta();
    this.#bindDrawer();
    this.#bindGridCollapse();
    this.#bindFilters();
    this.#bindLearnMore();
    this.#applyDefaultProducts();
    this.#render();
  }

  #applyDefaultProducts() {
    if (this.#cart.size > 0) return;
    const raw = this.dataset.defaultProducts;
    if (!raw) return;
    // Suppress the "first-add" drawer auto-expand for the silent default-population path.
    this.#hasAddedOnce = true;
    const entries = raw.split(',').map((s) => s.trim()).filter(Boolean);
    for (const entry of entries) {
      const [idStr, qtyStr] = entry.split(':');
      const productId = String(idStr || '').trim();
      const qty = Math.max(1, parseInt(qtyStr, 10) || 1);
      if (!productId) continue;
      const card = this.querySelector(`[data-fd-bb-card][data-product-id="${productId}"]`);
      if (card) this.#addToBundle(card, qty);
    }
  }

  disconnectedCallback() {
    // If the section is removed (e.g., theme editor reload), tidy up the portaled modal
    if (this.#modal && this.#modal.parentElement === document.body) {
      this.#modal.remove();
      this.#modal = null;
      document.body.classList.remove('fd-bb-modal-open');
    }
  }

  #bindFilters() {
    this.querySelectorAll('[data-fd-bb-filter]').forEach((tab) => {
      tab.addEventListener('click', (e) => {
        e.preventDefault();
        this.#applyFilter(tab);
      });
    });
    this.querySelectorAll('[data-fd-bb-filter-clear]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        this.#clearFilter(btn.dataset.filterType);
      });
    });
    this.#applyInitialFilters();
    // Run once on init so the grid is in sync with the default active tabs
    this.#runFilter();
    this.#updateClearVisibility();
  }

  #applyInitialFilters() {
    // Resolve initial filter values: URL params (if enabled) override schema defaults.
    let initialLine = this.dataset.defaultLine || '';
    let initialDemo = this.dataset.defaultDemo || '';

    if (this.hasAttribute('data-allow-url-filter-params')) {
      try {
        const params = new URLSearchParams(window.location.search);
        const urlLine = this.#firstParamValue(params, this.dataset.urlKeysLine);
        const urlDemo = this.#firstParamValue(params, this.dataset.urlKeysDemo);
        if (urlLine) initialLine = urlLine;
        if (urlDemo) initialDemo = urlDemo;
      } catch (_) {}
    }

    // Each can be comma-separated (e.g., ?line=multivitamins,probiotics)
    const splitVals = (s) => String(s || '').split(',').map((v) => v.trim()).filter(Boolean);
    splitVals(initialLine).forEach((v) => this.#activateFilterByValue('line', v));
    splitVals(initialDemo).forEach((v) => this.#activateFilterByValue('demo', v));
  }

  #firstParamValue(params, keysList) {
    if (!keysList) return '';
    const keys = String(keysList).split(',').map((s) => s.trim()).filter(Boolean);
    for (const key of keys) {
      const v = params.get(key);
      if (v && v.trim() !== '') return v.trim();
    }
    return '';
  }

  #activateFilterByValue(type, value) {
    const target = String(value).trim().toLowerCase();
    if (!target) return;
    const tabs = this.querySelectorAll(`[data-fd-bb-filter][data-filter-type="${type}"]`);
    for (const tab of tabs) {
      if (this.#normalize(tab.dataset.filterValue) === target) {
        // #applyFilter would toggle off if the tab were already active — at init
        // none are active so this safely turns the chip on.
        this.#applyFilter(tab);
        return;
      }
    }
  }

  #clearFilter(type) {
    if (!type) return;
    const set = this.#filters[type];
    if (set) set.clear();
    this.querySelectorAll(`[data-fd-bb-filter][data-filter-type="${type}"]`).forEach((t) => {
      t.classList.remove('fd-bb__filter-tab--active');
      t.setAttribute('aria-selected', 'false');
    });
    this.#runFilter();
    this.#updateClearVisibility();
  }

  #updateClearVisibility() {
    this.querySelectorAll('[data-fd-bb-filter-clear]').forEach((btn) => {
      const type = btn.dataset.filterType;
      const set = this.#filters[type];
      btn.hidden = !set || set.size === 0;
    });
  }

  #normalize(s) {
    return (s == null ? '' : String(s)).trim().toLowerCase();
  }

  #applyFilter(activeTab) {
    const type = activeTab.dataset.filterType;
    const value = this.#normalize(activeTab.dataset.filterValue);
    if (!value) return;
    const set = this.#filters[type];
    if (!set) return;

    // Multi-select: click toggles this chip's value in/out of the set;
    // other active chips in the same group stay active.
    const wasActive = set.has(value);
    if (wasActive) {
      set.delete(value);
      activeTab.classList.remove('fd-bb__filter-tab--active');
      activeTab.setAttribute('aria-selected', 'false');
    } else {
      set.add(value);
      activeTab.classList.add('fd-bb__filter-tab--active');
      activeTab.setAttribute('aria-selected', 'true');
    }

    this.#runFilter();
    this.#updateClearVisibility();
  }

  #runFilter() {
    // Within a group: ANY-match (a card matches if its value is in the active set).
    // Across groups: ALL-match (line AND demo must both pass).
    const lineSet = this.#filters.line;
    const demoSet = this.#filters.demo;
    this.querySelectorAll('[data-fd-bb-card]').forEach((card) => {
      const cardLine = this.#normalize(card.dataset.line);
      const cardDemo = this.#normalize(card.dataset.demo);
      const matchLine = lineSet.size === 0 || lineSet.has(cardLine);
      const matchDemo = demoSet.size === 0 || demoSet.has(cardDemo);
      card.hidden = !(matchLine && matchDemo);
    });
  }

  #bindDrawer() {
    const toggle = this.querySelector('[data-fd-bb-drawer-toggle]');
    if (!toggle) return;
    toggle.addEventListener('click', () => this.#toggleDrawer());
  }

  #bindGridCollapse() {
    const toggle = this.querySelector('[data-fd-bb-grid-toggle]');
    if (!toggle) return;
    toggle.addEventListener('click', () => this.#toggleGridCollapse());
  }

  #toggleGridCollapse() {
    const wrap = this.querySelector('[data-fd-bb-grid-wrap]');
    const toggle = this.querySelector('[data-fd-bb-grid-toggle]');
    const panel = this.querySelector('[data-fd-bb-grid-panel]');
    const label = this.querySelector('[data-fd-bb-grid-label]');
    if (!wrap || !toggle || !panel) return;
    const isExpanded = wrap.dataset.state === 'expanded';
    const next = isExpanded ? 'collapsed' : 'expanded';
    wrap.dataset.state = next;
    toggle.setAttribute('aria-expanded', String(!isExpanded));
    panel.hidden = isExpanded;
    if (label) {
      label.textContent = isExpanded
        ? toggle.dataset.collapsedLabel
        : toggle.dataset.expandedLabel;
    }
  }

  #bindLearnMore() {
    const modal = this.querySelector('[data-fd-bb-modal]') || this.#modal;
    if (!modal) return;

    // Portal the modal to <body> so it escapes any ancestor stacking context
    // (sticky headers, transforms, isolation) and truly sits on top of everything.
    // Copy the theme CSS variables onto the modal first so styles still resolve
    // once it's detached from the section.
    if (modal.parentElement !== document.body) {
      const sectionEl = this.closest('.fd-bb');
      if (sectionEl) {
        const cs = window.getComputedStyle(sectionEl);
        const varNames = [
          '--fd-bb-modal-bg', '--fd-bb-modal-text', '--fd-bb-modal-overlay',
          '--fd-bb-modal-overlay-op', '--fd-bb-modal-padding',
          '--fd-bb-modal-radius-d', '--fd-bb-modal-radius-m',
          '--fd-bb-modal-w-d', '--fd-bb-modal-h-m', '--fd-bb-modal-title-size',
          '--fd-bb-primary', '--fd-bb-primary-text', '--fd-bb-muted',
          '--fd-bb-border', '--fd-bb-success', '--fd-bb-cta-radius',
          '--fd-bb-font-body', '--fd-bb-font-head',
        ];
        for (const v of varNames) {
          const val = cs.getPropertyValue(v);
          if (val && val.trim()) modal.style.setProperty(v, val.trim());
        }
      }
      document.body.appendChild(modal);
    }
    this.#modal = modal;

    // Learn button clicks: still inside the section — delegate on host.
    this.addEventListener('click', (e) => {
      const learnBtn = e.target.closest('[data-fd-bb-learn]');
      if (learnBtn && this.contains(learnBtn)) {
        e.preventDefault();
        const card = learnBtn.closest('[data-fd-bb-card]');
        if (card) this.#openLearnMore(card);
        return;
      }
      // Preview-row item clicks open the same modal as the matching grid card
      const previewBtn = e.target.closest('[data-fd-bb-preview-learn]');
      if (previewBtn && this.contains(previewBtn)) {
        e.preventDefault();
        const pid = previewBtn.dataset.productId;
        if (!pid) return;
        const card = this.querySelector(`[data-fd-bb-card][data-product-id="${pid}"]`);
        if (card) this.#openLearnMore(card);
      }
    });

    // Close clicks: modal is now in <body>, so bind directly on it.
    modal.addEventListener('click', (e) => {
      const closeEl = e.target.closest('[data-fd-bb-modal-close]');
      if (closeEl) this.#closeLearnMore();
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modal.dataset.state === 'open') this.#closeLearnMore();
    });
  }

  #openLearnMore(card) {
    const modal = this.#modal || this.querySelector('[data-fd-bb-modal]');
    const content = modal?.querySelector('[data-fd-bb-modal-content]');
    const tpl = card.querySelector('[data-fd-bb-learn-template]');
    if (!modal || !content || !tpl) return;

    content.innerHTML = '';
    content.appendChild(tpl.content.cloneNode(true));

    // Sync the modal price with the card's current bundle-aware pricing.
    this.#renderModalPrice(card, content);
    // Track which card the modal is showing so #render() can keep the price in sync
    // if the cart changes while the modal is open.
    this.#openModalCard = card;

    // Wire the modal "Add to bundle" button to the card's add flow
    const modalAdd = content.querySelector('[data-fd-bb-modal-add]');
    if (modalAdd) {
      modalAdd.addEventListener('click', () => {
        const cardAdd = card.querySelector('[data-fd-bb-add]');
        if (cardAdd) cardAdd.click();
        const addedLabel = this.dataset.addedText || 'Added ✓';
        modalAdd.textContent = addedLabel;
        modalAdd.classList.add('fd-bb__modal-add--added');
      });
    }

    this.#bindModalGallery(content);

    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    // force reflow so the transition runs
    void modal.offsetWidth;
    modal.dataset.state = 'open';
    document.body.classList.add('fd-bb-modal-open');

    const closeBtn = modal.querySelector('.fd-bb__modal-close');
    if (closeBtn) closeBtn.focus({ preventScroll: true });
  }

  #closeLearnMore() {
    const modal = this.#modal || this.querySelector('[data-fd-bb-modal]');
    if (!modal || modal.dataset.state !== 'open') return;
    modal.dataset.state = 'closed';
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('fd-bb-modal-open');
    this.#openModalCard = null;
    const onEnd = () => {
      modal.hidden = true;
      const content = modal.querySelector('[data-fd-bb-modal-content]');
      if (content) content.innerHTML = '';
      modal.removeEventListener('transitionend', onEnd);
    };
    const panel = modal.querySelector('.fd-bb__modal-panel');
    if (panel) panel.addEventListener('transitionend', onEnd, { once: true });
    else onEnd();
  }

  #bindModalGallery(content) {
    const track = content.querySelector('[data-fd-bb-modal-track]');
    if (!track) return;
    const slides = track.querySelectorAll('.fd-bb__modal-slide');
    if (!slides.length) return;

    const dots = content.querySelectorAll('[data-fd-bb-modal-dot]');
    const thumbs = content.querySelectorAll('[data-fd-bb-modal-thumb]');
    const prev = content.querySelector('[data-fd-bb-modal-prev]');
    const next = content.querySelector('[data-fd-bb-modal-next]');

    const setActive = (idx) => {
      dots.forEach((d, i) => d.setAttribute('aria-current', String(i === idx)));
      thumbs.forEach((t, i) => t.setAttribute('aria-current', String(i === idx)));
    };

    const goTo = (idx) => {
      const target = slides[idx];
      if (target) track.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
    };

    setActive(0);

    track.addEventListener('scroll', () => {
      const w = track.clientWidth;
      const idx = Math.round(track.scrollLeft / w);
      setActive(idx);
    }, { passive: true });

    dots.forEach((dot) => {
      dot.addEventListener('click', () => goTo(parseInt(dot.dataset.index, 10) || 0));
    });
    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => goTo(parseInt(thumb.dataset.index, 10) || 0));
    });

    if (prev) prev.addEventListener('click', () => {
      const w = track.clientWidth;
      const idx = Math.max(0, Math.round(track.scrollLeft / w) - 1);
      goTo(idx);
    });
    if (next) next.addEventListener('click', () => {
      const w = track.clientWidth;
      const idx = Math.min(slides.length - 1, Math.round(track.scrollLeft / w) + 1);
      goTo(idx);
    });
  }

  #toggleDrawer() {
    const root = this.querySelector('[data-fd-bb-summary]');
    const toggle = this.querySelector('[data-fd-bb-drawer-toggle]');
    const panel = this.querySelector('[data-fd-bb-drawer-panel]');
    const label = this.querySelector('[data-fd-bb-drawer-label]');
    if (!root || !toggle || !panel) return;

    const isExpanded = root.dataset.state === 'expanded';
    const next = isExpanded ? 'collapsed' : 'expanded';

    root.dataset.state = next;
    toggle.setAttribute('aria-expanded', String(!isExpanded));
    panel.hidden = isExpanded;

    if (label) {
      label.textContent = isExpanded
        ? toggle.dataset.collapsedLabel
        : toggle.dataset.expandedLabel;
    }
  }

  #readTiers() {
    const count = parseInt(this.dataset.tierCount, 10) || 5;
    const out = [];
    for (let i = 1; i <= count; i++) {
      const qty = parseInt(this.dataset[`tier${i}Qty`], 10);
      const discount = parseFloat(this.dataset[`tier${i}Discount`]) || 0;
      if (!isNaN(qty)) out.push({ qty, discount });
    }
    return out.sort((a, b) => a.qty - b.qty);
  }

  #bindCards() {
    this.querySelectorAll('[data-fd-bb-card]').forEach((card) => {
      const qtyInc = card.querySelector('[data-fd-bb-qty-inc]');
      const qtyDec = card.querySelector('[data-fd-bb-qty-dec]');
      const qtyInput = card.querySelector('[data-fd-bb-qty-input]');
      const addBtn = card.querySelector('[data-fd-bb-add]');
      const variantSelect = card.querySelector('[data-fd-bb-variant]');

      qtyInc?.addEventListener('click', () => {
        if (!qtyInput) return;
        qtyInput.value = Math.min(99, (parseInt(qtyInput.value, 10) || 0) + 1);
        this.#renderCardPrice(card);
      });
      qtyDec?.addEventListener('click', () => {
        if (!qtyInput) return;
        qtyInput.value = Math.max(0, (parseInt(qtyInput.value, 10) || 0) - 1);
        this.#renderCardPrice(card);
      });
      qtyInput?.addEventListener('input', () => this.#renderCardPrice(card));

      variantSelect?.addEventListener('change', () => {
        const opt = variantSelect.options[variantSelect.selectedIndex];
        card.dataset.variantId = opt.value;
        card.dataset.productPrice = opt.dataset.price || card.dataset.productPrice;
        card.dataset.productCompare = opt.dataset.compare || card.dataset.productCompare;
        this.#renderCardPrice(card);
      });

      addBtn?.addEventListener('click', () => {
        const qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
        if (qtyInput) qtyInput.value = '0';
        this.#addToBundle(card, qty);
      });
    });
  }

  #addToBundle(card, qty) {
    const productId = card.dataset.productId;
    const existing = this.#cart.get(productId);

    if (existing) {
      existing.qty += qty;
    } else {
      this.#cart.set(productId, {
        productId,
        handle: card.dataset.productHandle,
        title: card.dataset.productTitle,
        image: card.dataset.productImage,
        variantId: card.dataset.variantId,
        price: parseInt(card.dataset.productPrice, 10) || 0,
        compare: parseInt(card.dataset.productCompare, 10) || 0,
        qty,
        isSubscription: this.#subscriptionDefault(),
        demo: card.dataset.demo || '',
        line: card.dataset.line || '',
      });
    }

    card.classList.add('fd-bb__card--active');
    const addBtn = card.querySelector('[data-fd-bb-add]');
    const addBtnText = card.querySelector('[data-fd-bb-add-text]');
    if (addBtn && addBtnText) {
      addBtn.classList.add('fd-bb__card-add--added');
      addBtnText.textContent = this.dataset.addedText || 'Added';
      setTimeout(() => {
        addBtn.classList.remove('fd-bb__card-add--added');
        addBtnText.textContent = this.dataset.addText || 'Add to Bundle';
      }, 1200);
    }

    const summary = this.querySelector('[data-fd-bb-summary]');
    const isFirstAdd = !this.#hasAddedOnce;
    this.#hasAddedOnce = true;
    if (isFirstAdd && summary?.dataset.state === 'collapsed') {
      this.#toggleDrawer();
    }

    this.#render();
  }

  #subscriptionDefault() {
    if (this.hasAttribute('data-subscription-only')) return true;
    return (this.dataset.subscriptionEnabled || 'false') === 'true';
  }

  #subscriptionOnly() {
    return this.hasAttribute('data-subscription-only');
  }

  #subscriptionDiscount() {
    return (parseFloat(this.dataset.subscriptionDiscount) || 0) / 100;
  }

  // Pure: returns { display, strike, showCompare } based on the card's current
  // qty stepper, the cart's total qty, subscription default, and tier preview.
  #computeCardPrice(card) {
    const base = parseInt(card.dataset.productPrice, 10) || 0;
    const compare = parseInt(card.dataset.productCompare, 10) || base;
    const qtyInput = card.querySelector('[data-fd-bb-qty-input]');
    const cardQty = qtyInput ? Math.max(0, parseInt(qtyInput.value, 10) || 0) : 0;
    const cartQty = this.#totalQty();
    const effectiveQty = cartQty + cardQty;

    if (effectiveQty === 0) {
      return { display: base, strike: base, showCompare: false };
    }

    const subOn = this.#subscriptionDefault();
    const subDisc = this.#subscriptionDiscount();
    const tierPct = (this.#tierFor(effectiveQty)?.discount || 0) / 100;
    let mult = 1;
    if (subOn) mult *= (1 - subDisc);
    if (tierPct) mult *= (1 - tierPct);
    const display = Math.round(base * mult);
    const strike = Math.max(compare, base);
    return { display, strike, showCompare: strike > display };
  }

  #renderCardPrice(card) {
    const { display, strike, showCompare } = this.#computeCardPrice(card);
    const priceEl = card.querySelector('[data-fd-bb-price-current]');
    const compareEl = card.querySelector('[data-fd-bb-price-compare] s');
    const compareWrap = card.querySelector('[data-fd-bb-price-compare]');
    if (priceEl) priceEl.textContent = this.#money(display);
    if (compareEl) compareEl.textContent = this.#money(strike);
    if (compareWrap) compareWrap.hidden = !showCompare;
  }

  #renderModalPrice(card, modalContent) {
    if (!card || !modalContent) return;
    const { display, strike, showCompare } = this.#computeCardPrice(card);
    const priceEl = modalContent.querySelector('[data-fd-bb-modal-price-current]');
    const compareEl = modalContent.querySelector('[data-fd-bb-modal-price-compare]');
    if (priceEl) priceEl.textContent = this.#money(display);
    if (compareEl) {
      compareEl.innerHTML = `<s>${this.#money(strike)}</s>`;
      compareEl.hidden = !showCompare;
    }
  }

  #tierFor(qty) {
    let match = null;
    for (const t of this.#tiers) {
      if (qty >= t.qty) match = t;
    }
    return match;
  }

  #renderAllCardPrices() {
    this.querySelectorAll('[data-fd-bb-card]').forEach((card) => this.#renderCardPrice(card));
  }

  #toggleSlotSubscription(slotIndex) {
    if (this.#subscriptionOnly()) return;
    const flat = [];
    for (const item of this.#cart.values()) {
      for (let i = 0; i < item.qty; i++) flat.push(item);
    }
    const target = flat[slotIndex];
    if (!target) return;
    target.isSubscription = !target.isSubscription;
    this.#render();
  }

  #removeSlot(slotIndex) {
    const entries = [...this.#cart.entries()];
    let cursor = 0;
    for (const [pid, item] of entries) {
      for (let i = 0; i < item.qty; i++) {
        if (cursor === slotIndex) {
          item.qty -= 1;
          if (item.qty <= 0) this.#cart.delete(pid);
          const card = this.querySelector(`[data-fd-bb-card][data-product-id="${pid}"]`);
          if (card && !this.#cart.has(pid)) card.classList.remove('fd-bb__card--active');
          this.#render();
          return;
        }
        cursor++;
      }
    }
  }

  #totalQty() {
    let total = 0;
    for (const item of this.#cart.values()) total += item.qty;
    return total;
  }

  #currentTier() {
    const qty = this.#totalQty();
    let match = null;
    for (const t of this.#tiers) {
      if (qty >= t.qty) match = t;
    }
    return match;
  }

  #render() {
    this.toggleAttribute('data-has-items', this.#cart.size > 0);
    this.#renderSlots();
    this.#renderTiers();
    this.#renderTotals();
    this.#renderAllCardPrices();
    this.#renderDrawerCount();
    if (this.#openModalCard) {
      const modal = this.#modal || this.querySelector('[data-fd-bb-modal]');
      const content = modal?.querySelector('[data-fd-bb-modal-content]');
      if (content) this.#renderModalPrice(this.#openModalCard, content);
    }
  }

  #renderDrawerCount() {
    const el = this.querySelector('[data-fd-bb-drawer-count]');
    if (!el) return;
    const qty = this.#totalQty();
    el.textContent = String(qty);
    el.hidden = qty === 0;
  }

  #renderSlots() {
    const slots = this.querySelectorAll('[data-fd-bb-slot]');
    const flat = [];
    for (const item of this.#cart.values()) {
      for (let i = 0; i < item.qty; i++) flat.push(item);
    }
    const subEnabled = this.#subscriptionDefault();
    const subOnly = this.#subscriptionOnly();
    const onLabel = this.dataset.subOnLabel || 'Subscribe';
    const offLabel = this.dataset.subOffLabel || 'One-time';

    slots.forEach((slot, idx) => {
      const item = flat[idx];
      const title = slot.querySelector('[data-fd-bb-slot-title]');
      const icon = slot.querySelector('.fd-bb__slot-icon');
      const remove = slot.querySelector('[data-fd-bb-slot-remove]');
      const unlock = slot.querySelector('.fd-bb__slot-unlock');
      const textWrap = slot.querySelector('.fd-bb__slot-text');

      // Remove any old sub toggle row
      const oldRow = slot.querySelector('[data-fd-bb-sub-row]');
      if (oldRow) oldRow.remove();

      if (item) {
        slot.classList.add('fd-bb__slot--filled');
        if (title) title.textContent = item.title;
        if (icon && item.image) icon.innerHTML = `<img src="${item.image}" alt="">`;
        if (remove) {
          remove.hidden = false;
          remove.onclick = () => this.#removeSlot(idx);
        }
        if (unlock) unlock.hidden = true;

        // Skip the per-slot toggle entirely in subscription-only mode — items
        // are always subscriptions and the toggle is meaningless.
        if (subEnabled && !subOnly && textWrap) {
          const row = document.createElement('span');
          row.className = 'fd-bb__slot-sub-row';
          row.setAttribute('data-fd-bb-sub-row', '');

          const label = document.createElement('span');
          label.className = 'fd-bb__slot-sub-label';
          label.textContent = item.isSubscription ? onLabel : offLabel;

          const toggle = document.createElement('button');
          toggle.type = 'button';
          toggle.className = 'fd-bb__slot-sub-toggle';
          toggle.setAttribute('data-fd-bb-sub-toggle', '');
          toggle.setAttribute('role', 'switch');
          toggle.setAttribute('aria-checked', String(item.isSubscription));
          toggle.setAttribute('aria-label', `Subscription — ${item.isSubscription ? onLabel : offLabel}`);
          toggle.dataset.on = item.isSubscription ? 'true' : 'false';
          toggle.addEventListener('click', () => this.#toggleSlotSubscription(idx));

          row.appendChild(label);
          row.appendChild(toggle);
          textWrap.appendChild(row);
        }
      } else {
        slot.classList.remove('fd-bb__slot--filled');
        if (title) title.textContent = this.#slotEmptyText();
        if (icon) icon.innerHTML = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M5 9l7-5 7 5v9a2 2 0 0 1-2 2h-4v-6h-2v6H7a2 2 0 0 1-2-2z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/></svg>`;
        if (remove) { remove.hidden = true; remove.onclick = null; }
        if (unlock) unlock.hidden = false;
      }

      // Empty slots are clickable → collapse the drawer & scroll to the grid/filters
      slot.onclick = (e) => {
        if (slot.classList.contains('fd-bb__slot--filled')) return;
        if (e.target.closest('[data-fd-bb-slot-remove], [data-fd-bb-sub-toggle]')) return;
        this.#collapseDrawerAndScroll();
      };
      slot.style.cursor = slot.classList.contains('fd-bb__slot--filled') ? 'default' : 'pointer';
    });

    // Overflow indicator when the cart contains more units than visible slots.
    const overflowBtn = this.querySelector('[data-fd-bb-slots-overflow]');
    if (overflowBtn) {
      const hidden = flat.length - slots.length;
      if (hidden > 0) {
        const text = overflowBtn.querySelector('[data-fd-bb-slots-overflow-text]');
        const tpl = overflowBtn.dataset.overflowTemplate || 'View all {count} items added';
        if (text) text.textContent = tpl.replace('{count}', String(flat.length));
        overflowBtn.hidden = false;
        if (!overflowBtn.dataset.bound) {
          overflowBtn.addEventListener('click', () => this.#submit());
          overflowBtn.dataset.bound = '1';
        }
      } else {
        overflowBtn.hidden = true;
      }
    }
  }

  #collapseDrawerAndScroll() {
    // Collapse the drawer if expanded
    const summary = this.querySelector('[data-fd-bb-summary]');
    if (summary && summary.classList.contains('fd-bb__summary--collapsible') && summary.dataset.state === 'expanded') {
      this.#toggleDrawer();
    }
    // Auto-apply the predominant demo filter from existing cart items
    this.#autoApplyDemoFilter();
    // Scroll to the filter bar (or the grid wrap if filters are off)
    const target = this.querySelector('[data-fd-bb-filters]') || this.querySelector('[data-fd-bb-grid]');
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  #predominantDemo() {
    if (this.#cart.size === 0) return '';
    const counts = new Map();
    for (const item of this.#cart.values()) {
      const d = this.#normalize(item.demo);
      if (!d) continue;
      counts.set(d, (counts.get(d) || 0) + item.qty);
    }
    if (!counts.size) return '';
    return [...counts.entries()].sort((a, b) => b[1] - a[1])[0][0];
  }

  #autoApplyDemoFilter() {
    // If the user has any filter (line or demo) already selected, leave it alone.
    if (this.#filters.demo.size > 0 || this.#filters.line.size > 0) return;
    const target = this.#predominantDemo();
    if (!target) return;
    const tabs = this.querySelectorAll('[data-fd-bb-filter][data-filter-type="demo"]');
    for (const tab of tabs) {
      if (this.#normalize(tab.dataset.filterValue) === target) {
        if (!tab.classList.contains('fd-bb__filter-tab--active')) {
          // #applyFilter would toggle off if it were already active — guaranteed it's not here
          this.#applyFilter(tab);
        }
        break;
      }
    }
  }

  #renderTiers() {
    const qty = this.#totalQty();
    const nodes = this.querySelectorAll('[data-tier-qty]');
    nodes.forEach((n) => {
      const threshold = parseInt(n.dataset.tierQty, 10);
      n.classList.toggle('fd-bb__tier--active', qty >= threshold);
    });
    // Connectors: active when both adjacent tiers are reached
    const connectors = this.querySelectorAll('.fd-bb__tier-connector');
    const tierNodes = [...nodes];
    connectors.forEach((c, i) => {
      const leftActive = tierNodes[i]?.classList.contains('fd-bb__tier--active');
      c.classList.toggle('fd-bb__tier-connector--active', Boolean(leftActive));
    });
  }

  #renderTotals() {
    const tier = this.#currentTier();
    const tierPct = (tier?.discount || 0) / 100;
    const subPct = this.#subscriptionDiscount();

    let subtotal = 0;
    let totalNet = 0;
    for (const item of this.#cart.values()) {
      const gross = item.price * item.qty;
      subtotal += gross;
      let mult = 1;
      if (item.isSubscription) mult *= (1 - subPct);
      mult *= (1 - tierPct);
      totalNet += gross * mult;
    }
    totalNet = Math.round(totalNet);
    const discount = subtotal - totalNet;

    // Panel subtotal + discount row (inside the collapsible drawer)
    const subEl = this.querySelector('[data-fd-bb-subtotal]');
    const discRow = this.querySelector('[data-fd-bb-discount-row]');
    const discEl = this.querySelector('[data-fd-bb-discount]');
    const discLabel = this.querySelector('[data-fd-bb-discount-label]');

    if (subEl) subEl.textContent = this.#money(subtotal);

    if (discount > 0 && discRow && discEl) {
      discRow.hidden = false;
      discEl.textContent = `-${this.#money(discount)}`;
      if (discLabel) {
        const parts = [];
        if (tier?.discount) parts.push(`Volume ${tier.discount}%`);
        const anySub = [...this.#cart.values()].some((i) => i.isSubscription);
        if (anySub && subPct > 0) parts.push(`Subscribe ${Math.round(subPct * 100)}%`);
        const prefix = (discLabel.dataset?.prefix || 'Bundle discount');
        discLabel.textContent = parts.length ? `${prefix} (${parts.join(' + ')})` : prefix;
      }
    } else if (discRow) {
      discRow.hidden = true;
    }

    // CTA button — total + strikethrough on the right
    const totalEl = this.querySelector('[data-fd-bb-total]');
    const compareEl = this.querySelector('[data-fd-bb-cta-compare]');
    const strikeEl = this.querySelector('[data-fd-bb-subtotal-strike]');
    const cta = this.querySelector('[data-fd-bb-cta]');

    if (totalEl) totalEl.textContent = this.#money(totalNet);
    if (strikeEl) strikeEl.textContent = this.#money(subtotal);
    if (compareEl) compareEl.hidden = !(discount > 0);
    if (cta) cta.disabled = this.#cart.size === 0;

    // Mini-tier highlights
    this.#renderMiniTiers();
  }

  #renderMiniTiers() {
    const qty = this.#totalQty();
    const tierNodes = this.querySelectorAll('[data-mini-tier-qty]');
    tierNodes.forEach((el) => {
      const threshold = parseInt(el.dataset.miniTierQty, 10);
      el.classList.toggle('fd-bb__mini-tier--active', qty >= threshold);
    });
    const connectors = this.querySelectorAll('.fd-bb__mini-tier-connector');
    const nodes = [...tierNodes];
    connectors.forEach((c, i) => {
      const leftActive = nodes[i]?.classList.contains('fd-bb__mini-tier--active');
      c.classList.toggle('fd-bb__mini-tier-connector--active', Boolean(leftActive));
    });
  }

  #bindCta() {
    const cta = this.querySelector('[data-fd-bb-cta]');
    if (!cta) return;
    cta.addEventListener('click', () => this.#submit());
  }

  async #submit() {
    const cta = this.querySelector('[data-fd-bb-cta]');
    const ctaText = this.querySelector('[data-fd-bb-cta-text]');
    if (!cta || this.#cart.size === 0) return;

    const original = ctaText?.textContent;
    cta.disabled = true;
    if (ctaText) ctaText.textContent = this.dataset.ctaAdding || 'Adding…';

    const sellingPlanId = this.dataset.sellingPlanId;
    const items = [...this.#cart.values()]
      .filter((i) => i.variantId)
      .map((i) => {
        const payload = {
          id: Number(i.variantId),
          quantity: i.qty,
          properties: { _bundle: 'true', _origin: 'bundle_builder' },
        };
        if (i.isSubscription && sellingPlanId) {
          payload.selling_plan = Number(sellingPlanId);
        }
        return payload;
      });

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items }),
      });
      if (!res.ok) throw new Error(`cart/add.js ${res.status}`);
      window.location.href = '/checkout';
    } catch (e) {
      console.error('[fd-bb] submit failed', e);
      if (ctaText) ctaText.textContent = this.dataset.ctaError || 'Error — try again';
      cta.disabled = false;
      setTimeout(() => {
        if (ctaText) ctaText.textContent = original || this.dataset.ctaText || 'Continue';
      }, 2400);
    }
  }

  #slotEmptyText() {
    const first = this.querySelector('[data-fd-bb-slot] [data-fd-bb-slot-title]');
    return first?.dataset?.emptyText || 'Select a Product';
  }

  #money(cents) {
    if (window.Shopify?.formatMoney) {
      return window.Shopify.formatMoney(cents, window.Shopify?.money_format || '${{amount}}');
    }
    return `$${(cents / 100).toFixed(2)}`;
  }
}

if (!customElements.get('firstday-bundle')) {
  customElements.define('firstday-bundle', FirstDayBundle);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["temp-sticky-footer-drawer"] && !Shopify.designMode) return;
  try {
    
  class StickyCta extends HTMLElement {
    /** @type {IntersectionObserver|null} */
    #observer = null;
    /** @type {Set<Element>} */
    #visibleTargets = new Set();

    connectedCallback() {
      const scrollBehavior = this.dataset.scrollBehavior === 'true';

      // Scroll behavior disabled — always visible, nothing to wire up.
      if (!scrollBehavior) return;

      const raw = this.dataset.target;
      if (!raw) return;

      // Wait for the full page to load so late-DOM elements (e.g. footer) exist.
      if (document.readyState === 'complete') {
        this.#init(raw);
      } else {
        window.addEventListener('load', () => this.#init(raw), { once: true });
      }
    }

    #init(raw) {
      const targets = raw.split(',')
        .map(s => document.getElementById(s.trim().replace(/^#/, '')))
        .filter(Boolean);

      if (!targets.length) return;

      this.#observer = new IntersectionObserver(
        this.#handleIntersection.bind(this),
        { threshold: 0.1 }
      );

      targets.forEach(t => this.#observer.observe(t));

      // Use a sentinel element + IntersectionObserver instead of a scroll
      // listener to detect when the user has scrolled past 200px. This avoids
      // firing JS on every scroll frame — the browser handles it natively.
      this.#sentinel = document.createElement('div');
      this.#sentinel.style.cssText = 'position:absolute;top:200px;left:0;width:1px;height:1px;pointer-events:none;';
      document.body.appendChild(this.#sentinel);

      this.#scrollGate = new IntersectionObserver((entries) => {
        this.#pastThreshold = !entries[0].isIntersecting;
        this.#evaluate();
      });
      this.#scrollGate.observe(this.#sentinel);
    }

    /** @type {IntersectionObserver|null} */
    #scrollGate = null;
    /** @type {HTMLElement|null} */
    #sentinel = null;
    /** @type {boolean} */
    #pastThreshold = false;

    disconnectedCallback() {
      this.#observer?.disconnect();
      this.#observer = null;
      this.#visibleTargets.clear();
      this.#scrollGate?.disconnect();
      this.#scrollGate = null;
      this.#sentinel?.remove();
      this.#sentinel = null;
    }

    /**
     * @param {IntersectionObserverEntry[]} entries
     */
    #handleIntersection(entries) {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          this.#visibleTargets.add(entry.target);
        } else {
          this.#visibleTargets.delete(entry.target);
        }
      }
      this.#evaluate();
    }

    /** Decide whether to show or hide based on both conditions. */
    #evaluate() {
      if (this.#pastThreshold && this.#visibleTargets.size === 0) {
        this.#show();
      } else {
        this.#hide();
      }
    }

    #show() {
      this.classList.add('is-visible');
      this.removeAttribute('aria-hidden');
    }

    #hide() {
      this.classList.remove('is-visible');
      this.setAttribute('aria-hidden', 'true');
    }
  }

  if (!customElements.get('sticky-cta')) {
    customElements.define('sticky-cta', StickyCta);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["temp-subnav"] && !Shopify.designMode) return;
  try {
    
  /**
   * <persona-pills> — scroll-spy active state, sticky shadow,
   * smooth scroll with reduced-motion support, focus-after-jump for SR users.
   */
  class PersonaPills extends HTMLElement {
    #scrollObserver = null;
    #stickyObserver = null;
    #pills = [];
    #targets = [];
    #focusTimeout = null;
    #scrollRAF = null;
    #cancelUserScroll = null;

    // Arrow function field: `this` is automatically bound to the instance,
    // so we don't need to (and can't) reassign it in connectedCallback.
    // The previous version used `this.#handleClick = this.#handleClick.bind(this)`
    // which throws TypeError because private methods are non-writable —
    // that error was silently breaking the click handler attachment.
    #handleClick = (event) => {
      const pill = event.currentTarget;
      const targetId = pill.dataset.target;
      if (!targetId) return;

      const target = document.getElementById(targetId);
      if (!target) return;

      event.preventDefault();

      // Cancel any pending focus and any in-flight scroll from a previous tap.
      this.#stopScroll();

      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const isMobile = window.matchMedia('(max-width: 749px)').matches;
      const offset = isMobile
        ? parseInt(this.dataset.jumpOffsetMobile, 10) || 0
        : parseInt(this.dataset.jumpOffsetDesktop, 10) || 0;

      // Compute destination: target's absolute top minus the offset amount.
      // Math.max keeps us from scrolling past the document start on near-top targets.
      const targetTop = target.getBoundingClientRect().top + window.scrollY;
      const destination = Math.max(0, targetTop - offset);

      if (history.replaceState) {
        history.replaceState(null, '', `#${targetId}`);
      }

      const focusable = target.querySelector('h1, h2, h3, [tabindex]') || target;
      if (!focusable.hasAttribute('tabindex')) focusable.setAttribute('tabindex', '-1');
      const finishFocus = () => {
        this.#focusTimeout = null;
        focusable.focus({ preventScroll: true });
      };

      if (reduced) {
        window.scrollTo(0, destination);
        finishFocus();
        return;
      }

      // Drive the scroll ourselves with rAF instead of the native
      // scrollTo({behavior:'smooth'}). On mobile Chrome the native smooth
      // scroll is cancelled the instant the URL bar collapses (which happens on
      // the first scroll from the top), so tapping a pill often did nothing
      // until you'd manually scrolled. A self-driven animation isn't subject to
      // that cancellation. We focus the target only after it settles, so the
      // focus() call can't interrupt the scroll either.
      this.#smoothScrollTo(destination, finishFocus);
    };

    #stopScroll() {
      if (this.#focusTimeout) {
        window.clearTimeout(this.#focusTimeout);
        this.#focusTimeout = null;
      }
      if (this.#scrollRAF) {
        window.cancelAnimationFrame(this.#scrollRAF);
        this.#scrollRAF = null;
      }
      if (this.#cancelUserScroll) {
        this.#cancelUserScroll();
        this.#cancelUserScroll = null;
      }
    }

    #smoothScrollTo(destination, onDone) {
      const start = window.scrollY;
      const distance = destination - start;
      const duration = 300;
      // easeInOutQuad
      const ease = (t) => (t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2);
      let startTime = null;

      // Let the user take over: any manual scroll/touch aborts our animation
      // so we never fight their input.
      const onUserScroll = () => this.#stopScroll();
      window.addEventListener('wheel', onUserScroll, { passive: true });
      window.addEventListener('touchmove', onUserScroll, { passive: true });
      this.#cancelUserScroll = () => {
        window.removeEventListener('wheel', onUserScroll, { passive: true });
        window.removeEventListener('touchmove', onUserScroll, { passive: true });
      };

      const step = (now) => {
        if (startTime === null) startTime = now;
        const t = Math.min(1, (now - startTime) / duration);
        window.scrollTo(0, start + distance * ease(t));
        if (t < 1) {
          this.#scrollRAF = window.requestAnimationFrame(step);
        } else {
          this.#scrollRAF = null;
          if (this.#cancelUserScroll) {
            this.#cancelUserScroll();
            this.#cancelUserScroll = null;
          }
          this.#focusTimeout = null;
          if (onDone) onDone();
        }
      };
      this.#scrollRAF = window.requestAnimationFrame(step);
    }

    connectedCallback() {
      this.#pills = Array.from(this.querySelectorAll('.persona-pills__pill'));
      if (this.#pills.length === 0) return;

      for (const pill of this.#pills) {
        const id = pill.dataset.target;
        if (id) {
          const el = document.getElementById(id);
          if (el) this.#targets.push({ id, el, pill });
        }
        pill.addEventListener('click', this.#handleClick);
      }

      this.#startScrollSpy();
      if (this.dataset.sticky === 'true') this.#startStickyShadow();
    }

    disconnectedCallback() {
      this.#scrollObserver?.disconnect();
      this.#stickyObserver?.disconnect();
      this.#stopScroll();
      for (const pill of this.#pills) {
        pill.removeEventListener('click', this.#handleClick);
      }
    }

    #startScrollSpy() {
      if (this.#targets.length === 0) return;
      this.#scrollObserver = new IntersectionObserver(
        (entries) => {
          let best = null;
          for (const entry of entries) {
            if (!entry.isIntersecting) continue;
            if (!best || entry.intersectionRatio > best.intersectionRatio) best = entry;
          }
          if (!best) return;
          const match = this.#targets.find((t) => t.el === best.target);
          if (match) this.#setActive(match.pill);
        },
        { rootMargin: '-30% 0px -50% 0px', threshold: [0, 0.25, 0.5, 1] }
      );
      for (const { el } of this.#targets) this.#scrollObserver.observe(el);
    }

    #setActive(activePill) {
      for (const pill of this.#pills) {
        if (pill === activePill) {
          pill.setAttribute('aria-current', 'location');
          pill.classList.add('persona-pills__pill--active');
        } else {
          pill.removeAttribute('aria-current');
          pill.classList.remove('persona-pills__pill--active');
        }
      }
    }

    #startStickyShadow() {
      const sentinel = this.querySelector('.persona-pills__sentinel');
      if (!sentinel) return;
      this.#stickyObserver = new IntersectionObserver(
        ([entry]) => this.classList.toggle('persona-pills--stuck', !entry.isIntersecting),
        { threshold: 0 }
      );
      this.#stickyObserver.observe(sentinel);
    }
  }

  if (!customElements.get('persona-pills')) {
    customElements.define('persona-pills', PersonaPills);
  }

  } catch(e) { console.error(e); }
})();
})();
